import { render, staticRenderFns } from "./JiaZhangMobile.vue?vue&type=template&id=da270074&scoped=true&"
import script from "./JiaZhangMobile.vue?vue&type=script&lang=js&"
export * from "./JiaZhangMobile.vue?vue&type=script&lang=js&"
import style0 from "./JiaZhangMobile.vue?vue&type=style&index=0&id=da270074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da270074",
  null
  
)

export default component.exports